<template>
  <NuxtLayout name="blog">
    <div class="blog-list">
      <ul class="blog-post-list">
        <li v-for="blog in blogPosts" :key="blog.pageTitle">
          <div v-if="blog.author" class="text-left">
            <!-- listing-author-wrapper -->
            <div class="row">
              <img
                :src="blog.author.photo"
                :alt="blog.author.name + ' | Trilon Consulting'"
                class="author-photo ml-3 rounded-circle"
              />
              <h6 class="pt-2 pl-3">
                <strong>{{ blog.author.name }}</strong>
                <br />
                <span v-if="blog.date">
                  on {{ blog.date }}
                  <span v-if="blog.readLength"></span>
                </span>
              </h6>
            </div>
          </div>

          <br class="clearfix" />

          <h3 class="mt-2">
            <a v-bind:href="blog.link">{{ blog.pageTitle }}</a>
          </h3>

          <!-- once we have imageName template complete and we have our cards with Trilon logo etc we can use this -->
          <!-- <img v-if="blog.imageName" :src="'https://trilon.io/blog/og-' + blog.imageName"
          :alt="blog.pageTitle + ' | Trilon Consulting'"
          class="blog-card"> -->

          <!-- use Medium photos for the time being -->
          <!-- <img v-if="blog.blogListingImage" :src="blog.blogListingImage"
          :alt="blog.pageTitle + ' | Trilon Consulting'"
          class="blog-card"> -->
          <!-- <h3>{{ blog.subTitle }}</h3> -->

          <p class="blog-description">{{ blog.description }}</p>

          <a :href="blog.link" class="btn btn-secondary">
            Read the Full Article
            <Arrow />
          </a>
        </li>
      </ul>
    </div>
  </NuxtLayout>
</template>

<script setup>
definePageMeta({
  blogList: true
})
const { $store: store } = useNuxtApp();
const blogPosts = ref(store.blogPosts)
</script>

<style lang="scss">
.blog-list ul.blog-post-list {
  margin: 0rem 0 3rem;
  padding: 0;

  h1,
  h2,
  h3,
  p {
    padding: initial;
  }

  img.blog-card {
    width: 100%;
    margin: 0;
  }

  h6 span {
    font-size: 0.9rem;
  }

  .listing-author-wrapper {
    background: #2a2356;
    border: 1px #3c356d solid;
    padding: 1rem 1rem 0.5rem 1rem;
    border-radius: 10px;
    max-width: 270px;
  }

  li {
    list-style-type: none;
    border-radius: 10px;
    padding: 3rem;
    margin: 5rem 0 3rem;
    border-top: 10px #2a2256 solid;
    background: #130e28;

    &:first-child {
      margin-top: 0;
    }
  }

  @media (max-width: 600px) {
    li {
      padding: 3rem 1rem;
    }
  }
}
</style>
